import React, { Component, createRef } from 'react';
import AppGroupService from '../serivces/appGroupService'
import SuperGroupService from '../serivces/superGroupService'
import LoginService from '../serivces/loginService';
import UserService from '../serivces/userService';
import AppService from '../serivces/appService';
import "./main2.css"
import {
  Search,
  LogOut,
  ChevronUp,
  ChevronDown,
  Grid2X2,
  Filter,
  LayoutDashboard,
  UsersRound,
  Boxes,
  ShieldCheck,
  ShieldAlert,
  RefreshCw,
  AppWindow,
  Plus,
  Pencil,
  Trash2,
  ChevronLeft,
  ChevronRight,
  CircleAlert,
  Zap,
  Menu,
  X
} from "lucide-react";

class MainPage2 extends Component {
  superGroupList = [];

  constructor(props) {
    super(props);
    this.appGroupService = new AppGroupService();
    this.superGroupService = new SuperGroupService();
    this.loginService = new LoginService();
    this.userService = new UserService();
    this.appService = new AppService();
    this.searchInputRef = createRef();
  }

  state = {
    user: {},
    superGroups: [],
    recentApps: [],
    query: "",
    source: "all",
    category: "all",
    sidebarOpen: false,
    currentPage: window.location.pathname === "/users" ? "users" : window.location.pathname === "/manage-apps" ? "manageApps" : "apps",
    users: [],
    usersTotal: 0,
    userSearch: "",
    userPage: 1,
    userPageSize: 20,
    usersLoading: false,
    userSaving: "",
    userError: "",
    roleModalUser: null,
    roleApps: [],
    roleSearch: "",
    selectedRoleAppIds: [],
    roleLoading: false,
    roleSaving: false,
    roleError: "",
    managedApps: [],
    managedAppsTotal: 0,
    managedAppsPage: 1,
    managedAppsPageSize: 20,
    managedAppGroups: [],
    managedAppsLoading: false,
    managedAppsError: "",
    managedAppsSearch: "",
    appEditor: null,
    appSaving: false,
    appEditorError: "",
    requestError: ""
  }

  handleShortcut = (event) => {
    const isSearchShortcut =
      event.key.toLowerCase() === "k" &&
      (event.ctrlKey || event.metaKey);

    if (isSearchShortcut) {
      event.preventDefault();

      this.searchInputRef.current?.focus();
      this.searchInputRef.current?.select();
    }

    if (event.key === "Escape") {
      this.searchInputRef.current?.blur();
      this.setState({ roleModalUser: null });
    }
  };

  componentDidMount = async () => {
    document.addEventListener('keydown', this.handleShortcut);
    window.addEventListener("popstate", this.handleRouteChange);
    window.addEventListener("workplace:request-error", this.handleRequestError);
    const user = await this.loginService.getCurrent();
    if (!user) return;
    this.setState({ user });
    this.syncRoute(user);
    const [groupsResult, recentApps] = await Promise.all([
      this.superGroupService.getList(),
      this.loginService.getRececntApp()
    ]);
    if (groupsResult?.items) {
      for (const superGroup of groupsResult.items) {
        for (const appGroup of superGroup.appGroups || []) {
          appGroup.thagricoapps = (appGroup.thagricoapps || []).filter((app) => !app.isHidden);
        }
      }
      this.superGroupList = groupsResult.items;
    }
    this.setState({
      superGroups: groupsResult?.items || [],
      recentApps: recentApps || []
    });
    if (user.isAdmin) {
      await this.loadUsers();
      if (window.location.pathname === "/manage-apps") await this.loadManagedApps();
    }
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleShortcut);
    window.removeEventListener("popstate", this.handleRouteChange);
    window.removeEventListener("workplace:request-error", this.handleRequestError);
  }

  syncRoute = (user = this.state.user) => {
    const routePages = { "/users": "users", "/manage-apps": "manageApps" };
    const requestedPage = routePages[window.location.pathname] || "apps";
    const page = requestedPage !== "apps" && !user?.isAdmin ? "apps" : requestedPage;
    const route = page === "users" ? "/users" : page === "manageApps" ? "/manage-apps" : "/apps";
    if (window.location.pathname !== route) window.history.replaceState({}, "", route);
    this.setState({ currentPage: page });
  }

  handleRouteChange = () => {
    this.syncRoute();
    if (this.state.user.isAdmin) {
      if (window.location.pathname === "/manage-apps") this.loadManagedApps();
      if (window.location.pathname === "/users") this.loadUsers({ page: 1 });
    }
  }

  handleRequestError = (event) => {
    this.setState({ requestError: event.detail || "Đã xảy ra lỗi khi kết nối đến hệ thống." });
  }

  loadRecentApps = () => {
    this.loginService.getRececntApp().then((apps) => {
      this.setState({ recentApps: apps })
    })
  }

  logout = (ev) => {
    this.loginService.logout().then((rs) => {
      if (rs.success) {
        this.props.gotoLogin();
      }
    });
    ev.preventDefault();
  }

  goToApp = (ev, appId) => {
    this.appGroupService.goToApp(appId).then((rs) => {
      this.loadRecentApps()
    })
    ev.preventDefault();
  }

  filterApp = (text) => {
    this.setState({ query: text });
  }

  loadUsers = async ({ page = this.state.userPage, pageSize = this.state.userPageSize, name = this.state.userSearch } = {}) => {
    if (!Boolean(this.state.user.isAdmin)) return;
    this.setState({ usersLoading: true, userError: "" });
    const result = await this.userService.getList({ page, count: pageSize, name });
    this.setState({
      users: result?.items || [],
      usersTotal: result?.count || 0,
      userPage: result?.page || page,
      userPageSize: result?.pageSize || pageSize,
      usersLoading: false,
      userError: result ? "" : "Không thể tải danh sách người dùng."
    });
  }

  searchUsers = (name) => {
    this.setState({ userSearch: name, userPage: 1 });
    this.loadUsers({ page: 1, name });
  }

  changeUserPageSize = (pageSize) => {
    const nextPageSize = Number(pageSize);
    this.setState({ userPage: 1, userPageSize: nextPageSize });
    this.loadUsers({ page: 1, pageSize: nextPageSize });
  }

  openRoleEditor = async (user) => {
    if (!this.state.user.isAdmin) return;
    this.setState({ roleModalUser: user, roleSearch: "", roleLoading: true, roleError: "", selectedRoleAppIds: [] });
    const [appsResult, userResult] = await Promise.all([
      this.appService.getList({ count: 10000 }),
      this.userService.getById(encodeURIComponent(user.userName))
    ]);
    if (!appsResult?.items || !userResult) {
      this.setState({ roleLoading: false, roleError: "Không thể tải danh sách app và quyền hiện tại." });
      return;
    }
    const roleIds = (userResult.appRoles || []).map((role) => Number(role.thagricoappId));
    this.setState({
      roleApps: appsResult.items.filter((app) => !app.isHidden),
      selectedRoleAppIds: roleIds,
      roleLoading: false
    });
  }

  toggleRoleApp = (appId) => {
    const id = Number(appId);
    this.setState((state) => ({
      selectedRoleAppIds: state.selectedRoleAppIds.includes(id)
        ? state.selectedRoleAppIds.filter((selectedId) => selectedId !== id)
        : [...state.selectedRoleAppIds, id]
    }));
  }

  saveUserRoles = async () => {
    const user = this.state.roleModalUser;
    if (!user || !this.state.user.isAdmin || this.state.roleSaving) return;
    this.setState({ roleSaving: true, roleError: "" });
    const result = await this.userService.updateRoles(user.userName, this.state.selectedRoleAppIds);
    if (result) {
      this.setState({ roleModalUser: null, roleSaving: false });
      return;
    }
    this.setState({ roleSaving: false, roleError: "Không thể lưu phân quyền ứng dụng." });
  }

  loadManagedApps = async ({ page = this.state.managedAppsPage, pageSize = this.state.managedAppsPageSize, name = this.state.managedAppsSearch } = {}) => {
    if (!this.state.user.isAdmin) return;
    this.setState({ managedAppsLoading: true, managedAppsError: "" });
    const [apps, groups] = await Promise.all([
      this.appService.getList({ page, count: pageSize, name }),
      this.state.managedAppGroups.length ? Promise.resolve({ items: this.state.managedAppGroups }) : this.appService.getAdminGroups()
    ]);
    this.setState({
      managedApps: apps?.items || [],
      managedAppsTotal: apps?.count || 0,
      managedAppsPage: apps?.page || page,
      managedAppsPageSize: apps?.pageSize || pageSize,
      managedAppGroups: groups?.items || [],
      managedAppsLoading: false,
      managedAppsError: apps && groups ? "" : "Không thể tải danh mục ứng dụng."
    });
  }

  searchManagedApps = (name) => {
    this.setState({ managedAppsSearch: name, managedAppsPage: 1 });
    this.loadManagedApps({ page: 1, name });
  }

  changeManagedAppsPageSize = (pageSize) => {
    const nextPageSize = Number(pageSize);
    this.setState({ managedAppsPage: 1, managedAppsPageSize: nextPageSize });
    this.loadManagedApps({ page: 1, pageSize: nextPageSize });
  }

  openAppEditor = (app = null) => {
    if (!this.state.user.isAdmin) return;
    this.setState({
      appEditor: app ? {
        id: app.id,
        name: app.name || "",
        description: app.description || "",
        appUrl: app.appUrl || "",
        image: app.image || "fa-folder",
        appColor: app.appColor || "#078548",
        svg: app.svg || "",
        appSource: app.appSource || "AGRI",
        idAppGroup: String(app.idAppGroup || app.appgroup?.id || ""),
        isPublic: Boolean(app.isPublic),
        isHidden: Boolean(app.isHidden)
      } : {
        name: "", description: "", appUrl: "", image: "fa-folder", appColor: "#078548", svg: "",
        appSource: "AGRI", idAppGroup: "", isPublic: false, isHidden: false
      },
      appEditorError: ""
    });
  }

  updateAppEditorField = (event) => {
    const { name, value, type, checked } = event.target;
    this.setState((state) => ({
      appEditor: { ...state.appEditor, [name]: type === "checkbox" ? checked : value }
    }));
  }

  saveManagedApp = async (event) => {
    event.preventDefault();
    const draft = this.state.appEditor;
    if (!draft || !this.state.user.isAdmin || this.state.appSaving) return;
    this.setState({ appSaving: true, appEditorError: "" });
    const payload = { ...draft, idAppGroup: draft.idAppGroup ? Number(draft.idAppGroup) : null };
    const result = draft.id
      ? await this.appService.update(payload)
      : await this.appService.create(payload);
    if (!result) {
      this.setState({ appSaving: false, appEditorError: "Không thể lưu ứng dụng. Kiểm tra dữ liệu và thử lại." });
      return;
    }
    this.setState({ appEditor: null, appSaving: false });
    await this.loadManagedApps();
    const refreshedGroups = await this.superGroupService.getList();
    if (refreshedGroups?.items) {
      for (const superGroup of refreshedGroups.items) {
        for (const appGroup of superGroup.appGroups || []) {
          appGroup.thagricoapps = (appGroup.thagricoapps || []).filter((item) => !item.isHidden);
        }
      }
      this.superGroupList = refreshedGroups.items;
      this.setState({ superGroups: refreshedGroups.items });
    }
  }

  deleteManagedApp = async (app) => {
    if (!this.state.user.isAdmin || !window.confirm(`Xóa ứng dụng "${app.name}" khỏi danh mục?`)) return;
    const result = await this.appService.delete(app.id);
    if (result) this.loadManagedApps();
  }

  toggleUserAdmin = async (target) => {
    if (!this.state.user.isAdmin || target.userName === this.state.user.userName || this.state.userSaving) return;
    const nextIsAdmin = !target.isAdmin;
    this.setState({ userSaving: target.userName, userError: "" });
    const updated = await this.userService.update({ userName: target.userName, isAdmin: nextIsAdmin });
    if (updated) {
      this.setState((state) => ({
        users: state.users.map((user) => user.userName === target.userName ? { ...user, isAdmin: nextIsAdmin } : user),
        userSaving: ""
      }));
      return;
    }
    this.setState({ userSaving: "", userError: "Không thể cập nhật quyền người dùng." });
  }

  openPage = (page) => {
    if (page !== "apps" && !this.state.user.isAdmin) return;
    const route = page === "users" ? "/users" : page === "manageApps" ? "/manage-apps" : "/apps";
    if (window.location.pathname !== route) window.history.pushState({}, "", route);
    this.setState({ currentPage: page, sidebarOpen: false });
    if (page === "manageApps") this.loadManagedApps();
  }

  getCatalogGroups = () => {
    const query = this.state.query.trim().toLocaleLowerCase();
    return this.superGroupList.flatMap((superGroup) => superGroup.appGroups || [])
      .map((group) => ({
        ...group,
        thagricoapps: (group.thagricoapps || []).filter((app) => {
          const appSource = app.appSource || "AGRI";
          return !app.isHidden &&
            (this.state.source === "all" || appSource === this.state.source) &&
            (this.state.category === "all" || String(group.id) === this.state.category) &&
            (!query || app.name.toLocaleLowerCase().includes(query));
        })
      }))
      .filter((group) => group.thagricoapps.length > 0);
  }

  render() {
    const { recentApps } = this.state;
    const appGroups = this.getCatalogGroups();
    const appCount = appGroups.reduce((total, group) => total + group.thagricoapps.length, 0);
    const categories = this.superGroupList.flatMap((group) => group.appGroups || []);
    const isAdmin = Boolean(this.state.user.isAdmin);
    const managedApps = this.state.managedApps;
    const managedAppsPageCount = Math.max(1, Math.ceil(this.state.managedAppsTotal / this.state.managedAppsPageSize));
    const managedAppsPageStart = this.state.managedAppsTotal === 0 ? 0 : (this.state.managedAppsPage - 1) * this.state.managedAppsPageSize + 1;
    const managedAppsPageEnd = Math.min(this.state.managedAppsPage * this.state.managedAppsPageSize, this.state.managedAppsTotal);
    const filteredUsers = this.state.users;
    const userPageCount = Math.max(1, Math.ceil(this.state.usersTotal / this.state.userPageSize));
    const userPageStart = this.state.usersTotal === 0 ? 0 : (this.state.userPage - 1) * this.state.userPageSize + 1;
    const userPageEnd = Math.min(this.state.userPage * this.state.userPageSize, this.state.usersTotal);
    const visibleRoleApps = this.state.roleApps.filter((app) => app.name.toLocaleLowerCase().includes(this.state.roleSearch.trim().toLocaleLowerCase()));
    return (
      <div className="workspace-layout">
        {this.state.requestError && <div className="request-error-toast" role="alert"><CircleAlert size={18}/><span>{this.state.requestError}</span><button type="button" onClick={() => this.setState({ requestError: "" })} aria-label="Đóng thông báo"><X size={16}/></button></div>}
        {this.state.sidebarOpen && <button className="sidebar-backdrop" type="button" aria-label="Đóng menu" onClick={() => this.setState({ sidebarOpen: false })} />}
        <aside className={`workspace-sidebar ${this.state.sidebarOpen ? "is-open" : ""}`} aria-label="Điều hướng chính">
          <a className="sidebar-brand" href="/" aria-label="THACO AGRI Workplace">
            <img src="/img/thaco-agri-logo.png" alt="THACO AGRI" />
            <span>Workplace</span>
          </a>
          <nav className="sidebar-nav">
            <button type="button" className="sidebar-nav-item" disabled title="Mục này chưa khả dụng"><LayoutDashboard size={19}/><span>Tổng quan</span></button>
            <button type="button" className={`sidebar-nav-item ${this.state.currentPage === "apps" ? "active" : ""}`} aria-current={this.state.currentPage === "apps" ? "page" : undefined} onClick={() => this.openPage("apps")}><Grid2X2 size={19}/><span>Ứng dụng</span></button>
            {isAdmin && <button type="button" className={`sidebar-nav-item ${this.state.currentPage === "users" ? "active" : ""}`} aria-current={this.state.currentPage === "users" ? "page" : undefined} onClick={() => this.openPage("users")}><UsersRound size={19}/><span>Quản lý người dùng</span></button>}
            {isAdmin && <button type="button" className={`sidebar-nav-item ${this.state.currentPage === "manageApps" ? "active" : ""}`} aria-current={this.state.currentPage === "manageApps" ? "page" : undefined} onClick={() => this.openPage("manageApps")}><Boxes size={19}/><span>Quản lý ứng dụng</span></button>}
          </nav>

          <section className="sidebar-shortcuts" aria-labelledby="shortcutTitle">
            <h2 id="shortcutTitle"><Zap size={15}/>TRUY CẬP NHANH</h2>
            {recentApps.slice(0, 5).map((app) => <button key={app.id} type="button" className="shortcut-item" onClick={(ev) => this.goToApp(ev, app.id)}>
              <span className="shortcut-app-icon" style={{ background: app.appColor || "#078548" }}>{app.svg ? <span dangerouslySetInnerHTML={{ __html: app.svg }} /> : app.name.slice(0, 2)}</span><b>{app.name}</b>
            </button>)}
            {recentApps.length === 0 && <p className="shortcut-empty">Ứng dụng đã mở gần đây sẽ hiển thị tại đây.</p>}
          </section>

          <div className="sidebar-bottom">
            <div className="security-card"><ShieldCheck size={20}/><span><strong>Truy cập được bảo vệ</strong><small>SSO • Phân quyền tập trung</small></span></div>
            <button className="sidebar-logout" type="button" onClick={this.logout}><LogOut size={18}/><span>Đăng xuất</span></button>
          </div>
        </aside>

        <div className="workspace-main">
          <header className="site-header">
            <div className="header-inner">
              <button className="sidebar-toggle" type="button" aria-label={this.state.sidebarOpen ? "Đóng menu" : "Mở menu"} onClick={() => this.setState({ sidebarOpen: !this.state.sidebarOpen })}>
                {this.state.sidebarOpen ? <X size={20}/> : <Menu size={20}/>}
              </button>

              <label className="global-search" aria-label="Tìm kiếm">
                <Search size={22} strokeWidth={1.8} />
                <input ref={this.searchInputRef} type="search" placeholder="Tìm kiếm ứng dụng..." value={this.state.query} onChange={(e) => this.filterApp(e.target.value)} />
                <kbd>⌘ K</kbd>
              </label>

              <nav className="header-actions" aria-label="Tiện ích">
                <button className="profile" aria-label="Tài khoản">
                  <span className="avatar">
                    {this.state.user.userName?.charAt(0)?.toUpperCase()}
                  </span>
                  <span className="profile-copy desktop-only">
                    <strong>{this.state.user.userName?.replace("@thaco.com.vn", "").toUpperCase() || 'User'}</strong>
                    <small></small>
                  </span>
                  <ChevronDown size={22} strokeWidth={1.8} className="desktop-only" />
                </button>
              </nav>
            </div>
          </header>

          {this.state.currentPage === "manageApps" && isAdmin ? <main className="page-shell user-management-page">
            <section className="user-page-heading">
              <div><span className="catalog-kicker">QUẢN TRỊ HỆ THỐNG</span><h1>Quản lý ứng dụng</h1><p>Danh mục ứng dụng THACO và THACO AGRI.</p></div>
              <button type="button" className="app-create-button" onClick={() => this.openAppEditor()}><Plus size={17}/><span>Thêm ứng dụng</span></button>
            </section>

            <section className="users-panel" aria-labelledby="managedAppsTitle">
              <div className="users-panel-heading"><div><h2 id="managedAppsTitle">Danh mục ứng dụng</h2><p>{this.state.managedAppsTotal} ứng dụng</p></div><label className="users-search"><Search size={17}/><input type="search" placeholder="Tìm tên ứng dụng..." value={this.state.managedAppsSearch} onChange={(event) => this.searchManagedApps(event.target.value)}/></label></div>
              {this.state.managedAppsError && <p className="users-error" role="alert">{this.state.managedAppsError}</p>}
              <div className="users-table-wrap">
                <table className="users-table managed-apps-table">
                  <thead><tr><th>Ứng dụng</th><th>Phân loại</th><th>Nhóm nghiệp vụ</th><th>Trạng thái</th><th>Thao tác</th></tr></thead>
                  <tbody>
                    {managedApps.map((app) => <tr key={app.id}>
                      <td><span className="managed-app-name"><i style={{ background: app.appColor || "#078548" }}>{app.svg ? <span dangerouslySetInnerHTML={{ __html: app.svg }} /> : <AppWindow size={17}/>}</i><span><strong>{app.name}</strong>{app.description && <small>{app.description}</small>}<small>{app.appUrl}</small></span></span></td>
                      <td><span className={`user-role ${app.appSource === "THACO" ? "admin" : "member"}`}>{app.appSource === "THACO" ? "Dùng chung THACO" : "Đặc thù THACO AGRI"}</span></td>
                      <td>{app.appgroup?.name || "Chưa phân nhóm"}</td>
                      <td><span className={`user-status ${app.isHidden ? "inactive" : "enabled"}`}><i/>{app.isHidden ? "Đang ẩn" : "Đang hiển thị"}</span></td>
                      <td className="user-action-cell"><div className="user-actions"><button className="user-role-action" type="button" onClick={() => this.openAppEditor(app)}><Pencil size={15}/>Chỉnh sửa</button><button className="user-role-action app-delete-action" type="button" onClick={() => this.deleteManagedApp(app)} aria-label={`Xóa ${app.name}`} title="Xóa ứng dụng"><Trash2 size={15}/></button></div></td>
                    </tr>)}
                    {!this.state.managedAppsLoading && !this.state.managedAppsError && managedApps.length === 0 && <tr><td colSpan="5" className="users-empty">{this.state.managedAppsSearch ? "Không tìm thấy ứng dụng phù hợp." : "Chưa có ứng dụng trong danh mục."}</td></tr>}
                    {this.state.managedAppsLoading && <tr><td colSpan="5" className="users-empty">Đang tải danh mục ứng dụng...</td></tr>}
                  </tbody>
                </table>
              </div>
              <footer className="users-pagination">
                <span>{managedAppsPageStart}–{managedAppsPageEnd} / {this.state.managedAppsTotal}</span>
                <label>Hiển thị
                  <select aria-label="Số ứng dụng mỗi trang" value={this.state.managedAppsPageSize} onChange={(event) => this.changeManagedAppsPageSize(event.target.value)}>
                    {[20, 50, 100].map((size) => <option key={size} value={size}>{size}</option>)}
                  </select>
                  mỗi trang
                </label>
                <div className="pagination-controls">
                  <button type="button" aria-label="Trang trước" disabled={this.state.managedAppsLoading || this.state.managedAppsPage <= 1} onClick={() => this.loadManagedApps({ page: this.state.managedAppsPage - 1 })}><ChevronLeft size={17}/></button>
                  <span>{this.state.managedAppsPage} / {managedAppsPageCount}</span>
                  <button type="button" aria-label="Trang sau" disabled={this.state.managedAppsLoading || this.state.managedAppsPage >= managedAppsPageCount} onClick={() => this.loadManagedApps({ page: this.state.managedAppsPage + 1 })}><ChevronRight size={17}/></button>
                </div>
              </footer>
            </section>
          </main> : this.state.currentPage === "users" && isAdmin ? <main className="page-shell user-management-page">
            <section className="user-page-heading">
              <div><span className="catalog-kicker">QUẢN TRỊ HỆ THỐNG</span><h1>Quản lý người dùng</h1><p>Danh sách tài khoản Workplace và quyền quản trị.</p></div>
              <button type="button" className="users-refresh" onClick={this.loadUsers} disabled={this.state.usersLoading} aria-label="Tải lại danh sách"><RefreshCw size={17}/><span>Làm mới</span></button>
            </section>

            <section className="users-panel" aria-labelledby="usersTableTitle">
              <div className="users-panel-heading"><div><h2 id="usersTableTitle">Tài khoản người dùng</h2><p>{this.state.usersTotal} tài khoản</p></div><label className="users-search"><Search size={17}/><input type="search" placeholder="Tìm theo email..." value={this.state.userSearch} onChange={(event) => this.searchUsers(event.target.value)}/></label></div>
              {this.state.userError && <p className="users-error" role="alert">{this.state.userError}</p>}
              <div className="users-table-wrap">
                <table className="users-table">
                  <thead><tr><th>Tài khoản</th><th>Trạng thái</th><th>Quyền truy cập</th><th>Thao tác</th></tr></thead>
                  <tbody>
                    {filteredUsers.map((user) => {
                      const isSelf = user.userName === this.state.user.userName;
                      const isSaving = this.state.userSaving === user.userName;
                      return <tr key={user.userName}>
                        <td><span className="user-account"><i>{user.userName.slice(0, 1).toUpperCase()}</i><span><strong>{user.userName}</strong><small>{isSelf ? "Tài khoản của bạn" : "THACO AGRI Workplace"}</small></span></span></td>
                        <td><span className={`user-status ${user.active ? "enabled" : "inactive"}`}><i/>{user.active ? "Hoạt động" : "Ngưng hoạt động"}</span></td>
                        <td><span className={`user-role ${user.isAdmin ? "admin" : "member"}`}>{user.isAdmin ? <><ShieldCheck size={15}/>Quản trị viên</> : <><UsersRound size={15}/>Người dùng</>}</span></td>
                        <td className="user-action-cell"><div className="user-actions">
                          <button type="button" className="user-role-action app-access-action" onClick={() => this.openRoleEditor(user)}><AppWindow size={15}/>Phân quyền app</button>
                          {isSelf ? <span className="self-account-label">Bạn</span> : <button type="button" className="user-role-action" disabled={Boolean(this.state.userSaving)} onClick={() => this.toggleUserAdmin(user)}>{isSaving ? "Đang lưu..." : user.isAdmin ? <><ShieldAlert size={15}/>Gỡ admin</> : <><ShieldCheck size={15}/>Cấp admin</>}</button>}
                        </div></td>
                      </tr>;
                    })}
                    {!this.state.usersLoading && !this.state.userError && filteredUsers.length === 0 && <tr><td colSpan="4" className="users-empty">{this.state.userSearch ? "Không tìm thấy tài khoản phù hợp." : "Chưa có người dùng."}</td></tr>}
                    {this.state.usersLoading && <tr><td colSpan="4" className="users-empty">Đang tải danh sách...</td></tr>}
                  </tbody>
                </table>
              </div>
              <footer className="users-pagination">
                <span>{userPageStart}–{userPageEnd} / {this.state.usersTotal}</span>
                <label>Hiển thị
                  <select aria-label="Số người dùng mỗi trang" value={this.state.userPageSize} onChange={(event) => this.changeUserPageSize(event.target.value)}>
                    {[20, 50, 100].map((size) => <option key={size} value={size}>{size}</option>)}
                  </select>
                  mỗi trang
                </label>
                <div className="pagination-controls">
                  <button type="button" aria-label="Trang trước" disabled={this.state.usersLoading || this.state.userPage <= 1} onClick={() => this.loadUsers({ page: this.state.userPage - 1 })}><ChevronLeft size={17}/></button>
                  <span>{this.state.userPage} / {userPageCount}</span>
                  <button type="button" aria-label="Trang sau" disabled={this.state.usersLoading || this.state.userPage >= userPageCount} onClick={() => this.loadUsers({ page: this.state.userPage + 1 })}><ChevronRight size={17}/></button>
                </div>
              </footer>
            </section>
          </main> : <main className="page-shell">
            <section className="catalog-intro">
            <div><span className="catalog-kicker">TRUNG TÂM ỨNG DỤNG</span><h1>Hệ sinh thái ứng dụng THACO AGRI</h1><p>Ứng dụng dùng chung từ THACO và ứng dụng đặc thù THACO AGRI trong một danh mục.</p></div>
            <div className="catalog-count"><strong>{appCount}</strong><span>ứng dụng phù hợp</span></div>
          </section>

          <section className="catalog-toolbar" aria-label="Bộ lọc ứng dụng">
            <label className="catalog-search"><Search size={18}/><input type="search" placeholder="Tìm tên ứng dụng..." value={this.state.query} onChange={(e) => this.filterApp(e.target.value)} /></label>
            <div className="source-tabs" role="group" aria-label="Nguồn ứng dụng">
              {[['all', 'Tất cả'], ['THACO', 'Dùng chung THACO'], ['AGRI', 'Đặc thù THACO AGRI']].map(([value, label]) => <button key={value} type="button" className={this.state.source === value ? 'active' : ''} onClick={() => this.setState({ source: value })}>{label}</button>)}
            </div>
            <label className="category-select"><Filter size={16}/><select aria-label="Lọc nhóm ứng dụng" value={this.state.category} onChange={(e) => this.setState({ category: e.target.value })}><option value="all">Tất cả nhóm nghiệp vụ</option>{categories.map((group) => <option key={group.id} value={String(group.id)}>{group.name}</option>)}</select></label>
          </section>

          <div className="catalog-groups">
            {appGroups.map((group) => <section key={group.id}>
              <div className="catalog-section-title"><span>{group.name.toLocaleUpperCase()}</span><i/><small>{group.thagricoapps.length} ứng dụng</small></div>
              <div className="catalog-app-grid">{group.thagricoapps.map((app) => <button type="button" key={app.id} className="catalog-app-card" onClick={(ev) => this.goToApp(ev, app.id)}>
                <span className="catalog-app-icon" style={{background: app.appColor || '#078548'}}>
                  {app.svg ? <span dangerouslySetInnerHTML={{ __html: app.svg }} /> : app.name.slice(0, 2)}
                </span><h2>{app.name}</h2>{app.description && <p className="catalog-app-description">{app.description}</p>}
                <footer><span className={`source-tag ${app.appSource === 'THACO' ? 'shared' : ''}`}>{(app.appSource || 'AGRI') === 'THACO' ? 'DÙNG CHUNG THACO' : 'ĐẶC THÙ THACO AGRI'}</span><ChevronUp size={16}/></footer>
              </button>)}</div>
            </section>)}
            {appCount === 0 && <div className="catalog-empty"><Grid2X2 size={30}/><h2>Chưa tìm thấy ứng dụng phù hợp</h2><p>Thử từ khóa hoặc bộ lọc khác.</p></div>}
            </div>
          </main>}

          {this.state.appEditor && <div className="role-modal-backdrop app-editor-backdrop" onMouseDown={(event) => { if (event.target === event.currentTarget && !this.state.appSaving) this.setState({ appEditor: null }); }}>
            <form className="role-modal app-editor-modal" onSubmit={this.saveManagedApp}>
              <header className="role-modal-header"><div><span className="catalog-kicker">QUẢN TRỊ DANH MỤC</span><h2>{this.state.appEditor.id ? "Chỉnh sửa ứng dụng" : "Thêm ứng dụng"}</h2><p>Cấu hình thông tin, nhóm và phạm vi hiển thị.</p></div><button type="button" aria-label="Đóng" disabled={this.state.appSaving} onClick={() => this.setState({ appEditor: null })}><X size={19}/></button></header>
              {this.state.appEditorError && <p className="users-error" role="alert">{this.state.appEditorError}</p>}
              <div className="app-editor-fields">
                <label className="app-editor-wide">Tên ứng dụng<input name="name" value={this.state.appEditor.name} onChange={this.updateAppEditorField} required maxLength="255" /></label>
                <label className="app-editor-wide">Mô tả ứng dụng<textarea name="description" value={this.state.appEditor.description} onChange={this.updateAppEditorField} rows="3" maxLength="2000" placeholder="Mô tả chức năng và phạm vi sử dụng của ứng dụng." /></label>
                <label className="app-editor-wide">Đường dẫn ứng dụng<input name="appUrl" type="url" value={this.state.appEditor.appUrl} onChange={this.updateAppEditorField} required /></label>
                <label>Phân loại<select name="appSource" value={this.state.appEditor.appSource} onChange={this.updateAppEditorField}><option value="THACO">Dùng chung THACO</option><option value="AGRI">Đặc thù THACO AGRI</option></select></label>
                <label>Nhóm nghiệp vụ<select name="idAppGroup" value={this.state.appEditor.idAppGroup} onChange={this.updateAppEditorField}><option value="">Chưa phân nhóm</option>{this.state.managedAppGroups.map((group) => <option key={group.id} value={group.id}>{group.name}</option>)}</select></label>
                <label>Ảnh / icon<input name="image" value={this.state.appEditor.image} onChange={this.updateAppEditorField} required /></label>
                <label>Màu ứng dụng<span className="app-color-input"><input name="appColor" type="color" value={this.state.appEditor.appColor} onChange={this.updateAppEditorField} required/><code>{this.state.appEditor.appColor}</code></span></label>
                <label className="app-editor-wide">SVG icon<textarea name="svg" value={this.state.appEditor.svg} onChange={this.updateAppEditorField} rows="4" placeholder="<svg ...>...</svg>" /></label>
                <label className="app-editor-toggle"><input name="isPublic" type="checkbox" checked={this.state.appEditor.isPublic} onChange={this.updateAppEditorField}/><span>Ứng dụng công khai cho mọi người dùng</span></label>
                <label className="app-editor-toggle"><input name="isHidden" type="checkbox" checked={this.state.appEditor.isHidden} onChange={this.updateAppEditorField}/><span>Ẩn khỏi danh mục ứng dụng</span></label>
              </div>
              <footer className="role-modal-footer"><span>{this.state.appEditor.id ? "Lưu thông tin ứng dụng" : "Ứng dụng mới trong danh mục"}</span><button type="button" className="role-cancel" disabled={this.state.appSaving} onClick={() => this.setState({ appEditor: null })}>Hủy</button><button type="submit" className="role-save" disabled={this.state.appSaving}>{this.state.appSaving ? "Đang lưu..." : "Lưu ứng dụng"}</button></footer>
            </form>
          </div>}

          {this.state.roleModalUser && <div className="role-modal-backdrop" onMouseDown={(event) => { if (event.target === event.currentTarget && !this.state.roleSaving) this.setState({ roleModalUser: null }); }}>
            <section className="role-modal" role="dialog" aria-modal="true" aria-labelledby="roleModalTitle">
              <header className="role-modal-header"><div><span className="catalog-kicker">PHÂN QUYỀN TRUY CẬP</span><h2 id="roleModalTitle">Ứng dụng được cấp</h2><p>{this.state.roleModalUser.userName}</p></div><button type="button" aria-label="Đóng" disabled={this.state.roleSaving} onClick={() => this.setState({ roleModalUser: null })}><X size={19}/></button></header>
              {this.state.roleError && <p className="users-error" role="alert">{this.state.roleError}</p>}
              <label className="role-app-search"><Search size={17}/><input type="search" placeholder="Tìm tên ứng dụng..." value={this.state.roleSearch} onChange={(event) => this.setState({ roleSearch: event.target.value })}/></label>
              <div className="role-app-list">
                {this.state.roleLoading ? <p className="role-list-status">Đang tải danh sách ứng dụng...</p> : visibleRoleApps.map((app) => <label className="role-app-option" key={app.id}>
                  <input type="checkbox" checked={this.state.selectedRoleAppIds.includes(Number(app.id))} onChange={() => this.toggleRoleApp(app.id)} />
                  <span className="role-app-check" aria-hidden="true"/>
                  <span className="role-app-copy"><strong>{app.name}</strong><small>{app.appSource === "THACO" ? "Dùng chung THACO" : "Đặc thù THACO AGRI"}</small></span>
                </label>)}
                {!this.state.roleLoading && visibleRoleApps.length === 0 && !this.state.roleError && <p className="role-list-status">{this.state.roleSearch ? "Không tìm thấy ứng dụng phù hợp." : "Không có ứng dụng trong danh mục."}</p>}
              </div>
              <footer className="role-modal-footer"><span>{this.state.selectedRoleAppIds.length} ứng dụng được chọn</span><button type="button" className="role-cancel" disabled={this.state.roleSaving} onClick={() => this.setState({ roleModalUser: null })}>Hủy</button><button type="button" className="role-save" disabled={this.state.roleLoading || this.state.roleSaving || Boolean(this.state.roleError)} onClick={this.saveUserRoles}>{this.state.roleSaving ? "Đang lưu..." : "Lưu phân quyền"}</button></footer>
            </section>
          </div>}
        </div>
      </div>)
  }
}
export default MainPage2;
